module.exports = __webpack_public_path__ + "static/media/ic_bank_added.798d40d7.svg";